import React from "react";
import { useTranslation } from "react-i18next";
import BookingFlowNotice from "./BookingFlowNotice";

interface SessionExpiredNoticeProps {
  /** Called when the guest chooses to restart their booking. */
  readonly onRestart: () => void;
}

/**
 * SessionExpiredNotice — shown when a pending booking can no longer be verified
 * (e.g. the checkout session expired while the browser was idle). It locks the
 * flow with a clear explanation and a single action to start again, preventing
 * the guest from paying for a booking the server would reject.
 */
const SessionExpiredNotice: React.FC<SessionExpiredNoticeProps> = ({ onRestart }) => {
  const { t } = useTranslation();

  return (
    <BookingFlowNotice
      title={t("session_expired_title", "Your session has expired")}
      message={t("session_expired_message", "Your session has timed out. Please re-start your booking.")}
      actionLabel={t("session_expired_restart", "Start again")}
      onAction={onRestart}
    />
  );
};

export default SessionExpiredNotice;
